export default __webpack_public_path__ + "static/media/WonProposal.7e927df5.svg";